import { render, staticRenderFns } from "./DescuentosDialog.vue?vue&type=template&id=952dad12"
import script from "./DescuentosDialog.vue?vue&type=script&lang=js"
export * from "./DescuentosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports